import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('categories')}},[_c('header-button',{attrs:{"slot":"right-button","icon":"mdi-plus-box","right":"","label":_vm.$t('new'),"to":{ name: 'administration-category-add' }},slot:"right-button"})],1),_c(VContainer,[_c('category-list-card',{attrs:{"categories":_vm.categories}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }